import {ACTION_MODEL} from '../../Helpers/ActionModel';
import PhotoPickerEdit from './SubComponent/SingleFiles/PhotoPickerEdit';
import ContentPhotoPicker from './SubComponent/SingleFiles/ContentPhotoPicker';
import CenterPhotoPicker from './SubComponent/CenterPhotoPicker';
import {FILE_TYPE} from '../../Helpers/fileType';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param string id: component identifier
 * @param model photoPicker: component model
 * @param useState setPhotoPicker: state to update the component model
 * @param string actionModel: string with option "create" or "update", this comes from the ACTION_MODEL
 * @param model accept: file formats and sizes accepted by the component
 * @param boolean showBtnDelete: default value is true, must be set to false if selected files are not required
 * @param boolean required:  default value is false, must be set to true if the field is required
 * @param boolean disabled: for the disabled component
 * @param boolean showBtnCamera: default value is false, must be set to true if the camera option is needed
 * @param boolean showBtnUpload: default value is true, must be set to false when the file can only be taken with the camera
 * @param boolean validateFace: default value is false, must be set to true if face validation is required
 * @param string titleModalEdit:  required if actionModel === ACTION_MODEL.UPDATE, title for modal
 * @param boolean showPreview: default value is true, must be set to false if preview visualization is not needed with the upload component
 * @param string classWith: for container size, used when centering the component (w-100, w-400px, other ), but it will always be centered
 * @param event handleDelete: required if actionModel === ACTION_MODEL.UPDATE and photo deletion is needed
 * @param string titleInput: title of the dashed-line component (file selection)
 * @param model typeSuggestions: required if showBtnCamera == true, the model must come from SUGGESTION_MODE_OPTION
 * @param boolean emptyFields: default value is false
 * @param state setDisplayModal: State management to ensure only one modal is visible at a time.
 * @param string btnNameUpdate: Name for the button that shows a preview of the file or photo, only used for the update action
 * @param boolean clear: default value is false, flag used to clear the selected file and reset the input state
 * @param useState setClear: state function used to update and reset the clear flag
 * @param string inputContainerClass: custom class name applied to the input container for styling purposes
 */
const CustomPhotoPicker = (
    {
        id, // component identifier
        photoPicker, // component model
        setPhotoPicker, // state to update the component model
        actionModel, // string with option "create" or "update", this comes from the ACTION_MODEL
        accept, // file formats and sizes accepted by the component
        showBtnDelete, // default value is true, must be set to false if selected files are not required
        required, // default value is false, must be set to true if the field is required
        disabled = false,
        defaultPreview = null, // image shown while the picker has no file selected
        showBtnCamera, // default value is false, must be set to true if the camera option is needed
        showBtnUpload = true, // default value is true, must be set to false when the file can only be taken with the camera
        validateFace, // default value is false, must be set to true if face validation is required
        titleModalEdit, // required if actionModel === ACTION_MODEL.UPDATE, title for modal
        showPreview, // default value is true, must be set to false if preview visualization is not needed with the upload component
        classWith, // for container size, used when centering the component
        handleDelete, // required if actionModel === ACTION_MODEL.UPDATE and photo deletion is needed
        titleInput, // title of the dashed-line component (file selection)
        typeSuggestions, // required if showBtnCamera == true, the model must come from SUGGESTION_MODE_OPTION
        emptyFields, // default value is false
        setDisplayModal=null, // default value is "", It can take the value "d-none"
        btnNameUpdate, // default value "upload_file", required if actionModel === ACTION_MODEL.UPDATE, Name for the button that shows a preview of the file or photo, only used for the update action
        clear, //Flag used to clear the file input.
        setClear, //Function to reset the clear flag.
        inputContainerClass // Custom class name applied to the input container for styling purposes
    }
) => {


   const btnCamera = showBtnCamera && accept.accept.includes(FILE_TYPE.IMAGE.accept);

    return(<>
        { actionModel === ACTION_MODEL.CREATE ?
            <CenterPhotoPicker classWith={classWith}>
                <ContentPhotoPicker
                    id={`${id}_${actionModel}`}
                    accept={accept}
                    photoPickerFile={photoPicker}
                    setPhotoPickerFile={setPhotoPicker}
                    titleInput={titleInput}
                    required={required}
                    disabled={disabled}
                    showBtnCamera={btnCamera}
                    showBtnUpload={showBtnUpload}
                    handleDelete={handleDelete}
                    validateFace={validateFace}
                    showBtnDelete={showBtnDelete}
                    showPreview={showPreview}
                    typeSuggestions={typeSuggestions}
                    emptyFields={emptyFields}
                    setDisplayModal={setDisplayModal}
                    clear={clear}
                    setClear={setClear}
                    inputContainerClass={inputContainerClass}
                />
            </CenterPhotoPicker>
            :
            <PhotoPickerEdit
                id={`${id}_${actionModel}`}
                accept={accept}
                photoPickerFile={photoPicker}
                setPhotoPickerFile={setPhotoPicker}
                titleInput={titleInput}
                disabled={disabled}
                defaultPreview={defaultPreview}
                showBtnCamera={btnCamera}
                handleDelete={handleDelete}
                validateFace={validateFace}
                showBtnDelete={showBtnDelete}
                showPreview={showPreview}
                classWith={classWith}
                titleModalEdit={titleModalEdit}
                actionModel={actionModel}
                typeSuggestions={typeSuggestions}
                emptyFields={emptyFields}
                setDisplayModal={setDisplayModal}
                btnNameUpdate={btnNameUpdate}
            />
        }
    </>);
};

export default CustomPhotoPicker;
